export default "__VITE_ASSET__cfc03c7d__"